import GetInvoiceShops from "../symbols/getInvoiceShops";
export interface InvoiceShop{
  Id:string;
  Name:string;
}
export interface MerchantInvoiceShop {
  ShopName: string;
  ShopId: string;
}
interface IState {
  data: InvoiceShop[];
  loading: boolean;
  error: boolean;
}
const initialState: IState = {
  data: [],
  loading: false,
  error: false,
};

export default function GetInvoiceShopsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case GetInvoiceShops.GET_INVOICE_SHOPS:
      return { ...state, loading: true, error: false };
    case GetInvoiceShops.GET_INVOICE_SHOPS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result as InvoiceShop[],
        loading: false,
        error: false,
      };
    case GetInvoiceShops.GET_INVOICE_SHOPS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case GetInvoiceShops.CLEAR_GET_INVOICE_SHOPS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
